import dayjs from 'dayjs'

export const utcToLocalTzWithoutTimeChange = (stringToConvert: string) =>
    dayjs.utc(stringToConvert).tz(dayjs.tz.guess(), true).toDate()
